import { Component, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { FunctionalCapabilitiesOCNAuthentication } from 'src/app/model/page/group/api-docs/functional-capabilities-order-change-notif-authentication';
import { ContentfulService } from 'src/app/service/contentful.service';
import { SharedDataService } from 'src/app/service/shared-data.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-functional-capabilities-ocn-authentication-page',
  templateUrl: './functional-capabilities-ocn-authentication-page.component.html',
  styleUrls: ['./functional-capabilities-ocn-authentication-page.component.scss']
})
export class FunctionalCapabilitiesOcnAuthenticationPageComponent implements OnInit {
  functionalCapabilitiesOCNAuthentication: FunctionalCapabilitiesOCNAuthentication = {} as FunctionalCapabilitiesOCNAuthentication;

  constructor(private contentfulService: ContentfulService, private sharedDataService: SharedDataService) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'functional-capabilities-ocn-authentication ') {
        this.functionalCapabilitiesOCNAuthentication.htmlTitle = title.htmlTitle;
      }
    });
    this.functionalCapabilitiesOCNAuthentication.tableSections = [];

    const query = { 'fields.title': 'OrderChangeNotif Authentication' };
    this.contentfulService.getPageContentResponse(query).then((ocnAuthenticationEntries) => {
      this.mapBanner(ocnAuthenticationEntries.includes.Entry);
      this.sharedDataService.addSharedData(this.functionalCapabilitiesOCNAuthentication.banner);
      this.mapTableSection(ocnAuthenticationEntries.includes.Entry);
      this.mapPageInfo(ocnAuthenticationEntries.items);
    });
  }

  private mapBanner(orderManagementPageEntries: Entry<any>[]) {
    orderManagementPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let imageDetails: any = entry.fields['image'];
    let videoDetails: any = entry.fields['video'];
    this.functionalCapabilitiesOCNAuthentication.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url as string,
      video: videoDetails?.fields?.file?.url  as string
    };
  }

  private mapTableSection(orderManagementPageEntries: Entry<any>[]) {
    orderManagementPageEntries
      .filter((entry) => ModelValidator.isTableSection(entry))
      .forEach((entry) => {
        this.mapEntryToTableSection(entry);
      });
  }

  private mapEntryToTableSection(entry: Entry<any>) {
    this.functionalCapabilitiesOCNAuthentication.tableSections.push({
      title: entry.fields['title'] as string,
      order: entry.fields['order'] as number,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      subBody: entry.fields['subBody'] as string,
      heading: entry.fields['heading'] as string,
      table: entry.fields['table'] as string,
    });
    this.functionalCapabilitiesOCNAuthentication.tableSections.sort((a, b) => a.order - b.order);
  }

  private mapPageInfo(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      let editorDetails = entry.fields?.editorDetails?.split('#');
      this.functionalCapabilitiesOCNAuthentication.banner.lastUpdated = entry.fields?.lastUpdated;
      this.functionalCapabilitiesOCNAuthentication.banner.url = entry.fields?.url;
      this.functionalCapabilitiesOCNAuthentication.banner.editorEmail = editorDetails?.pop();
      this.functionalCapabilitiesOCNAuthentication.banner.editorShortName = editorDetails?.pop();
      this.functionalCapabilitiesOCNAuthentication.banner.editorFullName = editorDetails?.pop();
      this.functionalCapabilitiesOCNAuthentication.htmlTitle = entry.fields.htmlTitle;
    });
  }
}
